// Add your styles here, and reference them in your component className
import { css } from '@linaria/core';
import { hjemlaColors } from '@style/themes/hjemla/colors';
import { fonts } from '@style/vars';

export const style = css`
  font-size: ${fonts.size.xxxs};
  color: ${hjemlaColors.redWarning};
`;
